export const TEXTAREA_MAX_LENGTH = 450;
export const ABOUT_MAX_LENGTH = 650;
